import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Header from './header';
import MainContent from './mainContent';
import Footer from './footer';
import BackToTop from './BackToTop';

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        const {
            content,
            content: { footer },
        } = this.props;

        return (
            <Fragment>
                <Header />
                <MainContent content={content} />
                <Footer content={footer} />
                <BackToTop />
            </Fragment>
        );
    }
}

export default Layout;
